import Name  from "../../../domain/fundamentals/name/Name";
import Staff from "../../../domain/staff/Staff";
import {
  ACTION_TYPE,
  SetStaff,
  SetStaffFirstName,
  SetStaffFirstNameKana,
  SetStaffGenderType,
  SetStaffLastName,
  SetStaffLastNameKana,
  SetStaffMemo,
  StaffAction
}            from "./StaffAction";

const reduceStaff = (action: SetStaff): Staff => action.staff;
const reduceLastName = (state: Staff, action: SetStaffLastName): Staff => new Staff(state.id, new Name(action.lastName, state.name.firstName, state.name.lastNameKana, state.name.firstNameKana), state.genderType, state.memo);
const reduceFirstName = (state: Staff, action: SetStaffFirstName): Staff => new Staff(state.id, new Name(state.name.lastName, action.firstName, state.name.lastNameKana, state.name.firstNameKana), state.genderType, state.memo);
const reduceLastNameKana = (state: Staff, action: SetStaffLastNameKana): Staff => new Staff(state.id, new Name(state.name.lastName, state.name.firstName, action.lastNameKana, state.name.firstNameKana), state.genderType, state.memo);
const reduceFirstNameKana = (state: Staff, action: SetStaffFirstNameKana): Staff => new Staff(state.id, new Name(state.name.lastName, state.name.firstName, state.name.lastNameKana, action.firstNameKana), state.genderType, state.memo);
const reduceGenderType = (state: Staff, action: SetStaffGenderType): Staff => new Staff(state.id, state.name, action.genderType, state.memo);
const reduceMemo = (state: Staff, action: SetStaffMemo): Staff => new Staff(state.id, state.name, state.genderType, action.memo);

const staffReducer = (state: Staff = new Staff(), action: StaffAction): Staff => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_STAFF:
      return reduceStaff(action as SetStaff);
    case ACTION_TYPE.SET_STAFF_LAST_NAME:
      return reduceLastName(state, action as SetStaffLastName);
    case ACTION_TYPE.SET_STAFF_FIRST_NAME:
      return reduceFirstName(state, action as SetStaffFirstName);
    case ACTION_TYPE.SET_STAFF_LAST_NAME_KANA:
      return reduceLastNameKana(state, action as SetStaffLastNameKana);
    case ACTION_TYPE.SET_STAFF_FIRST_NAME_KANA:
      return reduceFirstNameKana(state, action as SetStaffFirstNameKana);
    case ACTION_TYPE.SET_STAFF_GENDER_TYPE:
      return reduceGenderType(state, action as SetStaffGenderType);
    case ACTION_TYPE.SET_STAFF_MEMO:
      return reduceMemo(state, action as SetStaffMemo);
  }
};

export default staffReducer;
